import script from "./StaffLogin.vue?vue&type=script&setup=true&lang=js"
export * from "./StaffLogin.vue?vue&type=script&setup=true&lang=js"

import "./StaffLogin.vue?vue&type=style&index=0&id=001a71ea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-001a71ea"]])

export default __exports__